var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const unresolvedEventsOfType = new Map();
export const addIdToResolve = (type) => {
    if (!unresolvedEventsOfType.has(type)) {
        let promiseResolver = undefined;
        const eventsResolvedPromise = new Promise((resolve) => {
            promiseResolver = resolve;
        });
        unresolvedEventsOfType.set(type, {
            ids: new Set(),
            eventsResolvedPromise,
            promiseResolver
        });
    }
    return (payload) => {
        var _a;
        const idSet = (_a = unresolvedEventsOfType.get(type)) === null || _a === void 0 ? void 0 : _a.ids;
        const data = payload;
        if ((data === null || data === void 0 ? void 0 : data.id) !== undefined && idSet) {
            idSet.add(data.id);
        }
        return true;
    };
};
export const resolveIdAndRequireAll = (type) => {
    return (payload) => {
        const data = payload;
        const unresolvedEvents = unresolvedEventsOfType.get(type);
        if (!unresolvedEvents) {
            return true;
        }
        if ((data === null || data === void 0 ? void 0 : data.id) !== undefined) {
            if (data.id === "*") {
                unresolvedEvents.ids.clear();
            }
            else {
                unresolvedEvents.ids.delete(data.id);
            }
        }
        const resolved = unresolvedEvents.ids.size === 0;
        if (resolved && unresolvedEvents.promiseResolver !== undefined) {
            unresolvedEvents.promiseResolver(true);
            unresolvedEvents.eventsResolvedPromise = new Promise((resolve) => {
                unresolvedEvents.promiseResolver = resolve;
            });
        }
        return resolved;
    };
};
export const waitUntilAllResolved = (type) => {
    return (_payload) => __awaiter(void 0, void 0, void 0, function* () {
        const unresolvedIds = unresolvedEventsOfType.get(type);
        if (!unresolvedIds || unresolvedIds.ids.size === 0) {
            return true;
        }
        return unresolvedIds.eventsResolvedPromise;
    });
};
